import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MeetingFileDto } from '@shared/interfaces/dtos/meetings';
import { BaseHttpService } from './base-http.service';
import { UpdateMeetingFile } from '@shared/interfaces/meetings';

@Injectable({
  providedIn: 'root',
})
export class MeetingFilesService extends BaseHttpService {
  protected readonly endPoint: string = 'Seances';

  public fetchMeetingFiles(meetingId: number): Observable<MeetingFileDto[]> {
    return this.http.get<MeetingFileDto[]>(this.buildURL({ idOrSubEndpoint: `${meetingId}/Files` }));
  }

  public uploadMeetingFiles(meetingId: number, files: File[], asAttachement: boolean = false): Observable<unknown> {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`file ${index}`, file, file.name);
    });

    return this.http.post<unknown>(this.buildURL({ idOrSubEndpoint: `${meetingId}/MultipleFiles` }), formData, {
      params: { annexe: asAttachement },
    });
  }

  public downloadMeetingFile(meetingId: number, fileId: number): Observable<Blob> {
    return this.http.get<Blob>(this.buildURL({ idOrSubEndpoint: `${meetingId}/Files/${fileId}/Download` }), {
      responseType: 'blob' as 'json',
    });
  }

  public setMeetingFilesVisibility(
    meetingId: number,
    filesIds: number | number[],
    visibility: {
      visibleForRepresentatives?: boolean;
      visibleForCitizens?: boolean;
    }
  ): Observable<unknown> {
    const targets = Array.isArray(filesIds) ? filesIds : [filesIds];

    const body: {
      fileId: number;
      visibleDelibeWeb?: boolean;
      visibleDelibeWebCitoyen?: boolean;
    }[] = [];

    for (const target of targets) {
      body.push({
        fileId: target,
        visibleDelibeWeb: visibility.visibleForRepresentatives,
        visibleDelibeWebCitoyen: visibility.visibleForCitizens,
      });
    }

    return this.http.patch<unknown>(this.buildURL({ idOrSubEndpoint: `${meetingId}/Files` }), body);
  }

  public updateMeetingFile(meetingId: number, fileId: number, body: UpdateMeetingFile): Observable<unknown> {
    return this.http.patch<unknown>(this.buildURL({ idOrSubEndpoint: `${meetingId}/Files/${fileId}` }), body);
  }

  public deleteMeetingFile(meetingId: number, fileId: number): Observable<unknown> {
    return this.http.delete<unknown>(this.buildURL({ idOrSubEndpoint: `${meetingId}/Files/${fileId}` }));
  }

  public generateCompliantExtracts(
    meetingId: number,
    modeleId: number,
    body: { pointIds: number | number[] }
  ): Observable<unknown> {
    const targets = Array.isArray(body.pointIds) ? body.pointIds : [body.pointIds];

    return this.http.post(
      this.buildURL({ idOrSubEndpoint: `${meetingId}/ModelesDocuments/${modeleId}/MassGeneration` }),
      {
        pointIds: targets,
      }
    );
  }
}
